/* eslint-disable no-restricted-syntax */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';
import { useTestMic } from 'hooks';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function MicrophoneTest({ microphoneId }) {
  const { microphoneLevel } = useTestMic(microphoneId);
  const classes = useStyles();
  const theme = useTheme();
  const PIDS_COUNT = 8;
  const pids = Array(PIDS_COUNT)
    .fill()
    .map((_, i) => i);

  const pidsWrapper = useCallback(
    (node) => {
      if (node !== null) {
        const allPids = [...node.children];
        const pidsToColor = allPids.slice(0, microphoneLevel * (PIDS_COUNT / 50));
        for (const pid of allPids) pid.style.backgroundColor = theme.palette.disabled.main;
        for (const pid of pidsToColor) pid.style.backgroundColor = theme.palette.success.main;
      }
    },
    [microphoneLevel],
  );

  return microphoneId ? (
    <div data-testid="microphone-test" className={classes.pidsWrapper} ref={pidsWrapper}>
      {pids.map((i) => (
        <div className={classes.pid} key={i} />
      ))}
    </div>
  ) : null;
}

MicrophoneTest.propTypes = {
  microphoneId: PropTypes.string.isRequired,
};

export default MicrophoneTest;
